/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_ScheduleInputs */

const en_lessons_schedule = /** @type {(inputs: Lessons_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule lesson`)
};

const he_lessons_schedule = /** @type {(inputs: Lessons_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תזמון שיעור`)
};

/**
* | output |
* | --- |
* | "Schedule lesson" |
*
* @param {Lessons_ScheduleInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lessons_schedule = /** @type {((inputs?: Lessons_ScheduleInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_ScheduleInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lessons_schedule(inputs)
	return he_lessons_schedule(inputs)
});